import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedPhotoReference } from '../../models/serializable/localized-photo-reference.js';
import { LocalizedRichDescription } from '../../models/serializable/localized-rich-description.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';
export class LocalizedRichTextComponent extends RenderableComponent {
  static readonly TYPE_ID: string = '66f71c2039d44f7a91e0cbd4addd6706';
  static readonly DEFAULT_RENDER_ORDER: number = 12;

  constructor(
    public readonly titles: LocalizedString,
    public readonly richDescriptions: LocalizedRichDescription,
    public readonly photos: LocalizedPhotoReference,
    public readonly isRenderingEnabled: boolean,
    public readonly renderOrder: number,
    public readonly intentSolver: string | null,
    public readonly intentLabel: LocalizedString | null,
    public readonly alwaysExpanded: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return LocalizedRichTextComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedRichTextComponent {
    return new LocalizedRichTextComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromData<LocalizedRichDescription>(MapUtils.get<SerializedData>(map, 'richDescriptions')),
        context.fromData<LocalizedPhotoReference>(MapUtils.get<SerializedData>(map, 'photos')),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.getOrNull<string>(map, 'intentSolver'),
        context.fromDataOrNull<LocalizedString>(MapUtils.getOrNull<SerializedData>(map, 'intentLabel')),
        MapUtils.get<boolean>(map, 'alwaysExpanded'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'richDescriptions': context.toData(this.richDescriptions),
      'photos': context.toDataOrNull(this.photos),
      'isRenderingEnabled': this.isRenderingEnabled,
      'renderOrder': this.renderOrder,
      'intentSolver': this.intentSolver,
      'intentLabel': context.toDataOrNull(this.intentLabel),
      'alwaysExpanded': this.alwaysExpanded,
    };
  }

  clone(): this {
    return new LocalizedRichTextComponent(
        this.titles.clone(),
        this.richDescriptions.clone(),
        this.photos?.clone() ?? null,
        this.isRenderingEnabled,
        this.renderOrder,
        this.intentSolver,
        this.intentLabel?.clone() ?? null,
        this.alwaysExpanded,
    ) as this;
  }

  isSame(other: LocalizedRichTextComponent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.richDescriptions, this.richDescriptions) &&
      isSameData(other.photos, this.photos) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled &&
      other.intentSolver === this.intentSolver &&
      isSameData(other.intentLabel, this.intentLabel) &&
      other.alwaysExpanded === this.alwaysExpanded;
  }
}

export class LocalizedRichTextComponentBuilder extends DataModelBuilder<LocalizedRichTextComponent> {
  build(context: SerializationContext, map: SerializedData): LocalizedRichTextComponent {
    return LocalizedRichTextComponent.fromMap(context, map);
  }
}
